import { stringify } from 'qs';

import { ApiService } from '../../constants';
import { HttpService, fetchGlair } from '../../utilities';
import { getEventQuota } from "../event";

const getUserData: any = () => {
  const jsonString = localStorage.getItem('persist:root');
  const object = JSON.parse(jsonString);
  return JSON.parse(object.auth).userData;
};

export const getHomePageConfig = () => {
  const _userData = getUserData();
  return HttpService.post(ApiService.icdc.module.homePage.getConfig, {
    BusinessUnitCode: _userData.businessUnitCode
  });
};

export const getSocialMedia = () => {
  return HttpService.get(ApiService.icdc.module.homePage.getSosialMediaDetail);
};

export const getEventList = async ({ page, pageSize, targetAudience, jobBand }) => {
  const payload = {
    Page: page,
    Pagesize: pageSize,
    TargetAudience: targetAudience,
    SpecificJobBand: jobBand
  };

  let events = await HttpService.post(ApiService.beelajar.getEvent, payload);

  try {
    events.data = await getEventQuota(events.data)
  } catch (e){
    console.error('Error on getting event quota, error detail:', e);
  }

  return events
};

export const getSurvey = async () => {
  return await fetchGlair(ApiService.talent.survey, {
    method: 'GET'
  });
};

export const postSurvey = async (data: any[]) => {
  return await fetchGlair(ApiService.talent.survey, {
    method: 'POST',
    data
  });
};

export const getRecommendationList = async (params: {
  type: string;
  pageSize?: number;
  pageNumber?: number;
  jobDataID?: string;
}) => {
  return await fetchGlair(
    ApiService.talent.recommendation +
      stringify(params, { addQueryPrefix: true }),
    {
      method: 'GET'
    }
  );
};

export const addPoint = (data) => {
  return HttpService.post(ApiService.icdc.module.socialLearningPage.add, {
    ...data
  });
};

export const updateRecommendation = async (variables: {
  recommendationId: string;
  feedback: string;
}) => {
  const { recommendationId, feedback } = variables;
  return await fetchGlair(
    `${ApiService.talent.recommendation}/${recommendationId}`,
    {
      method: 'PUT',
      data: { feedback }
    }
  );
};

export const getPositionHorizontal = async () => {
  return await fetchGlair(ApiService.talent.positionsList, {
    method: 'GET'
  });
};

export const saveHomepageConfig = (data) => {
  return HttpService.post(ApiService.icdc.module.homePage.saveConfig, {
    ...data
  });
};

export const getHomepageContentList = () => {
  return HttpService.post(ApiService.icdc.module.homePage.getListContent, {
    contentTitle: '',
    page: 1,
    take: 100
  });
};
